import React from 'react'
import styled from '@emotion/styled'

import noAviaIcon from './no-avia.svg'
import outOfStockIcon from './out-of-stock.svg'
import intlDeliveryIcon from './intl-delivery.svg'

import {calcDiscount} from '../../../../universal-src/model/goods'
import Plural from '../../format/Plural'

const Root = styled.div`
  font: 12px/1.8 raleway, sans-serif;
  font-weight: 500;
`

const PropsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: inline-block;
    margin: 0 10px 0 0;
  }

  li:first-of-type:before {
    display: none;
  }

  li:before {
    content: "|";
    padding-right: 10px;
    color: #ccc;
  }
`

const LowAvailability = styled.div`
  color: #e61818;
`

const IntlDeliveryImg = styled.img`
  display: inline-block;
  position: relative;
  top: 1px;
  margin-right: 8px;
  vertical-align: baseline;
`

const NoAviaImg = styled.img`
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 8px;
  vertical-align: baseline;
`

const OutOfStockImg = styled.img`
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 8px;
  vertical-align: baseline;
`


export const GoodPropsList = ({
  good,
  activeCatalogType,
  currentUser,
}) => {
  let {
    outOfStock,
    numOfTokens,
    internationalDelivery,
    noAviaDelivery,
  } = good

  const discount = calcDiscount(activeCatalogType, good, currentUser)

  return <Root>
    <PropsList>
      {discount > 0 && <li>Клиентская скидка {discount}%</li>}
      {activeCatalogType.name === 'main' && (numOfTokens > 0
        ? <li><Plural value={numOfTokens} label="{жетон|жетона|жетонов}"/></li>
        : <li>Без жетона</li>)
      }
    </PropsList>
    <PropsList>
      {internationalDelivery && <li><IntlDeliveryImg
        src={intlDeliveryIcon}
        width={12}
        height={12}
        alt="Международная доставка"
        title="Международная доставка"
      />Международная доставка</li>}
      {noAviaDelivery && <li><NoAviaImg
        src={noAviaIcon}
        width={12}
        height={12}
        alt="Нет авиадоставки"
        title="Нет авиадоставки"
      />Нет авиадоставки</li>}
    </PropsList>
    {outOfStock && <LowAvailability><OutOfStockImg
      src={outOfStockIcon}
      width={13}
      height={13}
      alt="Нет на складе, возможна задержка при выдаче"
      title="Нет на складе, возможна задержка при выдаче"
    />Нет на складе, возможна задержка при выдаче</LowAvailability>}
  </Root>
}

const GoodPropsIconsRoot = styled.div`
  margin-right: 10px;
`

export const GoodPropsIcons = ({
  good
}) => {
  let {
    outOfStock,
    numOfTokens,
    internationalDelivery,
    noAviaDelivery,
  } = good

  if (!internationalDelivery && !noAviaDelivery && !outOfStock) return null

  return <GoodPropsIconsRoot>
    {false && internationalDelivery && <IntlDeliveryImg
      src={intlDeliveryIcon}
      width={12}
      height={12}
      alt="Международная доставка"
      title="Международная доставка"
    />}
    {noAviaDelivery && <NoAviaImg
      src={noAviaIcon}
      width={12}
      height={12}
      title="Нет авиадоставки"
      alt="Нет авиадоставки"
    />}
    {outOfStock && <OutOfStockImg
      src={outOfStockIcon}
      width={13}
      height={13}
      title="Нет на складе, возможна задержка при выдаче"
      alt="Нет на складе, возможна задержка при выдаче"
    />}
  </GoodPropsIconsRoot>
}
